const HideImage = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <path
        d="M23.5457 70.9494C20.8824 67.7477 19.6641 63.0444 19.6641 56.4994L19.6641 39.4994C19.6641 25.3327 25.3307 19.666 39.4974 19.666L56.4974 19.666C62.7024 19.666 67.2641 20.7427 70.4374 23.151"
        stroke="black"
        strokeWidth="5.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.251 36.6387C76.3077 37.5453 76.336 38.5087 76.336 39.5003L76.336 56.5003C76.336 70.667 70.6693 76.3337 56.5027 76.3337L39.5027 76.3337C37.406 76.3337 35.4793 76.2203 33.7227 75.937"
        stroke="black"
        strokeWidth="5.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6628 42.3333C39.7924 42.3333 42.3294 39.7963 42.3294 36.6667C42.3294 33.5371 39.7924 31 36.6628 31C33.5331 31 30.9961 33.5371 30.9961 36.6667C30.9961 39.7963 33.5331 42.3333 36.6628 42.3333Z"
        stroke="black"
        strokeWidth="5.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.3307 19.666L19.6641 76.3327"
        stroke="black"
        strokeWidth="5.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.3789 60.6079C47.2289 61.4579 48.6172 61.4579 49.4672 60.6079L63.7189 46.3279C65.9289 44.1179 69.4989 44.1179 71.7089 46.3279L76.3272 50.9746"
        stroke="black"
        strokeWidth="5.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HideImage;
